import { httpSmartClient } from "../../config/httpClient";

const baseName = "Reports";

const ReportsService = {
  getCount: async (reportState) => {
    var respone=await httpSmartClient.getById(`/${baseName}/Count?reportState=`+reportState);
    return respone;
  },
  getById: async (id) => {
    var respone=await httpSmartClient.getById(`/${baseName}/`+id);
    return respone;
  },

  getByParams: async (params) => {
    var respone=await httpSmartClient.getPaged(`/${baseName}/GetPaged`,{params});
    return respone;
  },

  add: async (report) => {
    var respone=await httpSmartClient.post(`/${baseName}`,report);
    return respone;
  },

  edit: async (country) => {
    var respone=await httpSmartClient.put(`/${baseName}`,country);
    return respone;
  },

  delete: async (id) => {
    var respone=await httpSmartClient.delete(`/${baseName}/`+id);
    return respone;
  },
  getDetail: async (id) => {
    var respone=await httpSmartClient.get(`/${baseName}/GetDetail?reportId=${id}`);
    return respone;
  },
  changeStatus: async (report) => {
    var response = await httpSmartClient.put(`/${baseName}/ChangeStatus`,report);
    return response;
  },
  
};

export default ReportsService;
